import { CompanyIcon } from '@/components/CompanyIcon';
import { useTrendingStocks } from '@/components/Search/hooks/useTrendingStocks';

type Props = {
  onCompanySelect: (canonicalUrl: string) => void;
};

const TrendingStocksGridViewIdProd = 376743;
const TrendingStocksGridViewIdDev = 292980;

export const NarrativeMiniValuatorTrendingCompanies = ({
  onCompanySelect,
}: Props) => {
  const { data: trendingStocks = [], status: trendingStocksFetchStatus } =
    useTrendingStocks({
      gridViewId:
        SWS_ENV === 'prod' || SWS_ENV === 'staging'
          ? TrendingStocksGridViewIdProd
          : TrendingStocksGridViewIdDev,
      limit: 4,
    });

  if (trendingStocksFetchStatus === 'pending')
    return (
      <div className="grid grid-cols-[repeat(4,minmax(auto,80px))] grid-rows-[80px] gap-x1">
        <div className="bones animate-pulse"></div>
        <div className="bones animate-pulse"></div>
        <div className="bones animate-pulse"></div>
        <div className="bones animate-pulse"></div>
      </div>
    );

  if (trendingStocksFetchStatus === 'error')
    return <div className="text-softer">No popular companies found</div>;

  return (
    <div
      role="group"
      className="grid grid-cols-[repeat(4,minmax(auto,80px))] gap-x1"
    >
      {trendingStocks.map((company) => (
        <button
          key={company.canonicalURL}
          type="button"
          onClick={() => onCompanySelect(company.canonicalURL)}
          aria-label={`Select ${company.name}`}
          className="focus-outline rounded-x1 hover:scale-110 [&>*]:!h-auto [&>*]:!w-full"
        >
          <CompanyIcon
            size={74}
            tickerSymbol={company.tickerSymbol}
            website={company.info.url}
          />
        </button>
      ))}
    </div>
  );
};
